define('modules/emblue/view',['require','exports','module','views/BaseView','env','ldsh!./template'],function (require, exports, module) {
  "use strict";

  var BaseView = require("views/BaseView"),
    Config = require("env");

  var Layout = BaseView.extend({
    template: require("ldsh!./template"),
    migrationStatus: false,
    returnUrl: false,
    events: {
      "click #goToBack": "goToBack",
    },

    beforeRender: function () {},

    initialize: function (options) {
      this.migrationStatus = this.options.migrationStatus;
    },

    serialize: function () {
      console.log(this.migrationStatus);

      if (this.migrationStatus == false) {
        return {
          tab: this.options.tab,
          status: false,
        };
      }

      if (
        this.migrationStatus.status == 1 ||
        this.migrationStatus.status == 3
      ) {
        return {
          tab: this.options.tab,
          status: this.migrationStatus.status,
          groupId: this.migrationStatus.groupId,
          email: this.findEmailinInfo(this.migrationStatus.info),
        };
      }

      return {
        tab: this.options.tab,
        status: this.migrationStatus.status,
      };
    },

    findEmailinInfo: function (info) {
      const resultado = info.find(
        (item) => item.data && item.data.status === 0
      );

      if (resultado) {
        return resultado.data.email;
      } else {
        return "unknown";
      }
    },
    goToBack: function (event) {
      event.preventDefault();
      event.stopPropagation();
      window.location = this.returnUrl;
    },
  });

  module.exports = Layout;
});

